module.exports = __webpack_public_path__ + "static/img/ill_constitution.png";